/**
 * L2-R6: moved to @miq/platform-ui (components/bg-image/bg-image.component.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform-ui'.
 */
export { BgImageComponent } from '@miq/platform-ui';
